
import store from '@/store';
import { Component, Prop, Vue } from 'vue-property-decorator';

type UserFile = File & {
  data: string;
  filename: string;
};

@Component
export default class DropZone extends Vue {
  @Prop({ type: String, required: false, default: 'Drop files here or ' }) public text!: string;
  @Prop({ type: String, required: false, default: 'choose from device' }) public link!: string;
  @Prop({ type: String, required: false, default: 'default' }) public type!: string;
  @Prop({ type: Array, required: false, default: () => [] }) public allowedFormats!: string;
  @Prop({ type: Boolean, required: false, default: true }) public multiple!: boolean;

  private highlight = false;
  private openFileSelection(): void {
    const fileInput = this.$refs.fileInput as HTMLElement;
    fileInput.click();
  }

  private onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.highlight = true;
  }

  private onDragLeave(): void {
    this.highlight = false;
  }

  private onDrop(event: DragEvent): void {
    event.preventDefault();
    const dataTransfer = event.dataTransfer;
    if (dataTransfer) {
      const files: FileList = dataTransfer.files as FileList;
      const result: File[] = [];
      for (const file of files) {
        const fileType: string = file.type;
        if (this.allowedFormats.indexOf(fileType) > -1 || this.allowedFormats.length === 0) {
          const reader = new FileReader();
          // zammad requires base64 encoding for files
          reader.onloadend = () => {
            let b64;
            b64 = reader.result as string;
            b64 = b64.replace(/^data:.+;base64,/, '');
            (file as UserFile).data = b64;
          };
          reader.readAsDataURL(file);
          file['mime-type'] = file.type;
          (file as UserFile).filename = file.name;
          result.push(file);
          this.highlight = false;
        } else {
          store.dispatch('setNetworkError', 'Wrong file format');
        }
      }
      if (files.length > 0) {
        this.$emit('filesAdded', result);
      }
    } else {
      store.dispatch('setNetworkError', 'Something went wrong');
    }
  }
  private onFileChanged(event: Event) {
    const files: FileList = (event.target as HTMLInputElement).files as FileList;
    const result: File[] = [];
    for (const file of files) {
      const fileType: string = file.type;
      if (this.allowedFormats.indexOf(fileType) > -1 || this.allowedFormats.length === 0) {
        const reader = new FileReader();
        // zammad requires base64 encoding for files
        reader.onloadend = () => {
          let b64;
          b64 = reader.result as string;
          b64 = b64.replace(/^data:.+;base64,/, '');
          (file as UserFile).data = b64;
        };
        reader.readAsDataURL(file);

        file['mime-type'] = file.type;
        (file as UserFile).filename = file.name;
        result.push(file);
      } else {
        store.dispatch('setNetworkError', 'Wrong file format');
      }
    }

    if (files.length > 0) {
      this.$emit('filesAdded', result);
    }
  }
}
